// versions/v105/notice.js
import icon_clothing from '@icoach/assets/img/icon_doc_clothing.png';
import icon_cross_store from '@icoach/assets/img/icon_doc_cross_store.png';
import icon_renew from '@icoach/assets/img/icon_doc_renew.png';
import icon_prohibited from '@icoach/assets/img/icon_doc_prohibited.png';
import icon_sport from '@icoach/assets/img/icon_doc_sport.png';
import icon_suspension from '@icoach/assets/img/icon_doc_suspension.png';
import icon_termination from '@icoach/assets/img/icon_doc_termination.png';
import { Alert } from "@curves/ui-base";
import React from "react";

const notice105 = [
	{
		icon: icon_clothing,
		title: '運動服裝守則：合適且禮貌的穿著讓您舒適運動、效果加倍！',
		details: [
			'請穿著有袖上衣。',
			'請穿著長度過膝的運動褲。',
			'請穿著乾淨的室內運動鞋。',
			'建議配戴運動手套，除了提升舒適及穩定性之外，還能保護您纖纖玉手。',
		],
	},
	{
		icon: icon_prohibited,
		title: '來店守則：讓您享受專屬您的30分鐘運動，開心盡興！',
		details: [
			'Curves 採會員制，請勿帶孩童進入店舖。',
			'請勿攜帶寵物。',
		],
	},
	{
		icon: icon_sport,
		title: '運動方式：遵照Curves專業指導進行30分鐘完整運動，安全又有效！',
		details: [
			'請依順時針交換下一台器材/踏板，未經教練指示請勿任意跳過器材或踏板。',
			'請依語音指示替換器材和踏板，完整運動包含依序使用器材/踏板24分鐘與指定伸展動作6分鐘。',
			'踏板目的是讓心跳恢復、肌肉休息，在踏板上維持輕鬆踏步即可。',
		],
	},
	{
		icon: icon_cross_store,
		title: '跨店運動',
		details: [
			'加入之新會員，於原店舖完成前5次運動後，方可開始跨店運動。',
			'凡為每月自動扣款之會員，皆可於全台各店舖免費跨店運動。',
			'跨店前請向教練申請跨店資格，並且確認跨店店舖之營業時間，方可進行跨店運動。',
		],
		WarnComponent: () => (
			<Alert variant="filled" severity="info" color="info">
				為了提供理想的運動環境，若有未能遵守以上事項者，店舖有權禁止運動。
			</Alert>
		)
	},
	{
		icon: icon_renew,
		title: '會員權續約優惠',
		details: [
			'指契約期限屆滿後，接續與本公司締結新契約⽽未中斷時，無須繳納入會費。',
			'已完成⼆年方案之會員，若於續約期滿前終止契約，如有應補繳費用時，免予補繳。',
		],
	},
	{
		icon: icon_suspension,
		title: '會員權暫停',
		details: [
			'會員得於契約期限屆滿前，應「以月為單位」辦理，本人親自赴所屬店舖辦理暫停會員權。',
			'為配合銀行作業，會員須於暫停月份前一個月的20號(含)前提出申請。',
			'因出國逾一個月者，持相關證明親自辦理。',
			'經醫師指示暫時不宜運動且開立診斷書證明者，持診斷證明書辦理。',
		],
	},
	{
		icon: icon_termination,
		title: '會員權終止',
		details: [
			'會員得於契約期限屆滿前，本人親自赴所屬店舖辦理。',
			'為了保障會員權益，請事先與本公司預約時間，辦理相關流程。',
			'終止手續費：以簽約時月平均價格乘以契約期間未到期月數之20%(未滿十五日者以半月計，逾十五日者以一月計)。學生方案期間退會，無須收取終止手續費。',
			'會員應補繳費用超過3,800元者，本公司最高僅收取3,800元',
		],
		WarnComponent: () => (
			<Alert variant="filled" severity="info" color="info">
				續約、暫停及終止因涉及會員權益與金額之認定，務必親自赴所屬店舖辦理。
			</Alert>
		)
	},
];

// 105 版不分新約/續約/新生，故忽略 membershipType、memberType 參數；
// 仍保留與其他版本一致的 getNotice(membershipType, memberType) 簽章，供 resolveVersion() 統一呼叫。
export const getNotice = () => notice105;

export default notice105;
